import { render } from "./BaseUserDataF.vue?vue&type=template&id=eba704a8"
import script from "./BaseUserDataF.vue?vue&type=script&lang=js"
export * from "./BaseUserDataF.vue?vue&type=script&lang=js"

import exportComponent from "C:\\agent\\_work\\55\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__